import Vue from "vue";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    UploadedUsers: [],
    Supervisors: [],
    Departments: [],
    Roles: [],
    RolePermissions: [],
    Groups: [],

    UserMasterProperties: {},
    CreatedUserList: []
  };
}

const state = initialState();

const actions = {
  uploadUsersInfoFile: function(context, file) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/core/users/load", file)
        .then(
          function(data) {
            if (data && data.data.Data) {
              //  context.commit("updateUploadedUsers", data.data.Data);
              resolve(data.data.Data);
            }
          },
          err => {
            resolve(false);
          }
        )
        .catch(function(error) {
          console.log("something Happened", error);
          reject(error);
        });
    });
  },
  getSupervisorList: function(context, params) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/core/users/status/1")
        .then(function(data) {
          context.commit(
            "updateSupervisors",
            data.data.Data.sort(HelperFunctions.sortByProperty("FirstName"))
          );
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDepartments: function(context, params) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("core/groups/org")
        .then(function(data) {
          context.commit("updateDepartments", data.data.Data);
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  checkForRegisteredEmail: function(context, email) {
    return new Promise((resolve, reject) => {
      Vue.http
        .put("core/users/email/" + encodeURIComponent(email) + "/?")
        .then(function(data) {
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  GetAllRolePermissions: function(context, params) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("RolePermissions/GetAllPermissions")
        .then(function(data) {
          context.commit("updateRolePermissions", data.data.Data);
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  GetAllManagerGroups: function(context, params) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("core/groups/manager")
        .then(function(data) {
          context.commit("updateGroups", data.data.Data);
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  processUserRecords: async function(context, users) {
    const response = await Vue.http.post("core/users/bulkcreate", users).catch(err => err.response);
    if(response && response.data && response.data.Success)  context.commit("updateCreatedUserList", response.data.Data || []);
    return response;
  }
};

const mutations = {
  updateUploadedUsers: function(state, data) {
    state.UploadedUsers = data;
  },
  updateSupervisors: function(state, data) {
    state.Supervisors = data;
  },
  updateDepartments: function(state, data) {
    state.Departments = data;
  },
  updateMasterProperties: function(state, data) {
    state.UserMasterProperties = data;
  },
  updateRolePermissions: function(state, data) {
    state.RolePermissions = data;
  },
  updateGroups: function(state, data) {
    state.Groups = data;
  },
  updateCreatedUserList: function(state, data) {
    state.CreatedUserList = data;
  }
};

const getters = {
  UploadedUsers: function() {
    return state.UploadedUsers;
  },
  UserMasterProperties: function() {
    return state.UserMasterProperties;
  },
  Supervisors: function() {
    return state.Supervisors;
  },
  Departments: function() {
    return state.Departments;
  },
  Roles: function() {
    return state.Roles;
  },
  RolePermissions: function() {
    return state.RolePermissions;
  },
  Groups: function() {
    return state.Groups;
  },
  CreatedUserList: function() {
    return state.CreatedUserList;
  }
};

export default {
  actions,
  mutations,
  getters,
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/BulkUserUpload.js